/*!
 * @Author: leo
 * @Date: 2019-12-25 20:55:00
 * @Last Modified by: Robin
 * @Last Modified time: 2024-07-23 10:06:46
 * @Instruduction: 公共处理接口方法
 */

import { Message } from 'element-ui'
import { UserModule } from '@/store/modules/user'

function commonSuccessHandler(res: any) {
    const data = res.data
    // 判断 token 是否失效，失效跳转到登录页面
    if (data.status === 411) {
        UserModule.resetUser()
        window.location.href='#/login'
    }
    return {
        status: data.status,
        message: data.message,
        data: data.data
    }
}

function commonErrorHandler() {
    // 错误提示
    Message.error('接口请求失败，请联系客服或重试')
    return {
        status: -1,
        message: '接口请求失败，请重试',
        data: {}
    }
}

export { commonSuccessHandler, commonErrorHandler }
